/*--------------------------------------------------------------
# Archive results without a page reload
--------------------------------------------------------------*/

/**
 * Archives rendered by \Illustrate\Archive_Layout wrap the filters form and the results in
 * [data-board-archive]. Instead of submitting the form, this script requests the same archive
 * URL with `board_archive_partial=1`, which answers with the results region only, swaps it in
 * and keeps the address bar in sync, so the URL can still be shared or reloaded.
 *
 * Without this script (or if a request fails) the form submits as a normal GET request.
 */
(function () {
  var PARTIAL_QUERY_ARG = "board_archive_partial";
  var FILTER_DELAY = 200;
  var SEARCH_DELAY = 350;
  var MIN_SEARCH_LENGTH = 2;

  var initArchive = function (root) {
    var form = root.querySelector(".js-board-archive-taxonomy-filters");
    var results = root.querySelector("[data-board-archive-results]");
    var status = root.querySelector("[data-board-archive-status]");
    var searchInput = form
      ? form.querySelector('.board-archive-taxonomy-filters__search input[type="search"]')
      : null;

    if (!form || !results || !window.fetch || !window.URLSearchParams) {
      return;
    }

    var controller = null;
    var timer = null;
    var lastSearch = searchInput ? searchInput.value.trim() : "";

    /** URL of the archive for the current state of the form, always on page 1. */
    var getFormUrl = function () {
      var url = new URL(form.action, window.location.href);
      url.search = "";

      new FormData(form).forEach(function (value, key) {
        if (typeof value === "string" && value.trim() !== "") {
          url.searchParams.append(key, value.trim());
        }
      });

      return url;
    };

    var hasActiveFilters = function (url) {
      var active = false;
      url.searchParams.forEach(function (value, key) {
        if (key === "bs" || key === "board_filters_search" || /^b(f|oard_filters)\[/.test(key)) {
          active = true;
        }
      });

      return active;
    };

    var setLoading = function (isLoading) {
      root.classList.toggle("is-loading", isLoading);
      results.setAttribute("aria-busy", isLoading ? "true" : "false");
    };

    var announce = function () {
      var count = results.querySelector("[data-board-archive-count]");
      if (status && count) {
        status.textContent = count.textContent.trim();
      }
    };

    var load = function (url, options) {
      options = options || {};
      window.clearTimeout(timer);

      var requestUrl = new URL(url.toString());
      requestUrl.searchParams.set(PARTIAL_QUERY_ARG, "1");

      if (controller) {
        controller.abort();
      }
      controller = new AbortController();

      setLoading(true);

      return window
        .fetch(requestUrl.toString(), {
          credentials: "same-origin",
          headers: { "X-Requested-With": "XMLHttpRequest" },
          signal: controller.signal,
        })
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Archive results request failed: " + response.status);
          }

          return response.text();
        })
        .then(function (html) {
          results.innerHTML = html;
          window.history.replaceState(window.history.state, "", url.toString());

          root.ownerDocument
            .querySelectorAll("[data-board-archive-unfiltered-only]")
            .forEach(function (element) {
              element.hidden = hasActiveFilters(url);
            });

          announce();
          setLoading(false);

          if (options.scroll) {
            var top = root.getBoundingClientRect().top + window.pageYOffset - 120;
            window.scrollTo({ top: Math.max(top, 0), behavior: "smooth" });
          }

          root.dispatchEvent(
            new CustomEvent("board:archive-updated", {
              bubbles: true,
              detail: { url: url.toString() },
            }),
          );
        })
        .catch(function (error) {
          if (error && error.name === "AbortError") {
            return;
          }

          // Fall back to a normal page load of the same state.
          window.location.assign(url.toString());
        });
    };

    var schedule = function (delay) {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        load(getFormUrl());
      }, delay);
    };

    form.addEventListener("change", function (event) {
      if (event.target.matches('[data-board-filter] input[type="checkbox"]')) {
        schedule(FILTER_DELAY);
      }
    });

    if (searchInput) {
      searchInput.addEventListener("input", function () {
        var value = searchInput.value.trim();
        if (value === lastSearch) {
          return;
        }
        if (value.length > 0 && value.length < MIN_SEARCH_LENGTH) {
          return;
        }

        lastSearch = value;
        schedule(value === "" ? FILTER_DELAY : SEARCH_DELAY);
      });
    }

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      lastSearch = searchInput ? searchInput.value.trim() : "";

      // The mobile "Apply filters" button closes the panel and brings the results into view.
      var closesPanel = form.classList.contains("is-mobile-filters-open");
      if (closesPanel) {
        form.classList.remove("is-mobile-filters-open");
        var mobileToggle = form.querySelector("[data-board-mobile-filters-toggle]");
        if (mobileToggle) {
          mobileToggle.setAttribute("aria-expanded", "false");
        }
      }

      load(getFormUrl(), { scroll: closesPanel });
    });

    results.addEventListener("click", function (event) {
      var pageLink = event.target.closest(".pagination a[href]");
      if (pageLink) {
        event.preventDefault();
        load(new URL(pageLink.href, window.location.href), { scroll: true });
        return;
      }

      // "No results" reset: empty the search and clear every filter, then reload once.
      if (event.target.closest("[data-board-clear-all-filters]")) {
        event.preventDefault();
        if (searchInput) {
          searchInput.value = "";
          lastSearch = "";
        }
        form.dispatchEvent(new CustomEvent("board:archive-filters-clear"));
        load(getFormUrl());
      }
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-board-archive]").forEach(initArchive);
  });
})();
